module.exports = __webpack_public_path__ + "static/media/9DESA10.9cc0eb06.jpg";